import React, { FC } from 'react';

import { useTranslation } from '../../translations';

import hjerte from '../../resources/hjerte.svg';

const TilbakemeldingTakk: FC = () => {
    const { kvittering } = useTranslation();

    return (
        <div style={{ textAlign: 'center' }}>
            <img src={hjerte} alt="Hjerte" width={84} height={56} className="margin-bottom-smaller" />
            <h3 className="title margin-bottom-smaller">{kvittering.infoTilbakemeldingTakk}</h3>
            <span>{kvittering.infoTilbakemeldingViktig}</span>
        </div>
    );
};

export default TilbakemeldingTakk;
